export {default} from './responsive-dimension-values';
